/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Body1Inputs */

const en_sorter_body1 = /** @type {(inputs: Sorter_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A canonical key order is worth having because JSON has no inherent one. Two services can emit the same data with keys in different sequences, and a text diff will call that a change. Sorting both sides first removes the disagreement, so what remains in the diff is a real difference in values.`)
};

const ko_sorter_body1 = /** @type {(inputs: Sorter_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON에는 고유한 키 순서가 없기 때문에 정규 순서를 갖는 것은 가치가 있습니다. 두 서비스가 같은 데이터를 다른 키 순서로 내보낼 수 있고, 텍스트 diff는 그것을 변경으로 취급합니다. 양쪽을 먼저 정렬하면 이 불일치가 사라지고, diff에 남는 것은 값의 실제 차이뿐입니다.`)
};

const ja_sorter_body1 = /** @type {(inputs: Sorter_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON には固有のキー順序がないため、正規の順序を持つことには価値があります。2 つのサービスが同じデータを異なるキー順で出力することがあり、テキスト差分はそれを変更として扱います。両方を先に並べ替えればこの食い違いは消え、差分に残るのは値の実際の違いだけになります。`)
};

/**
* | output |
* | --- |
* | "A canonical key order is worth having because JSON has no inherent one. Two services can emit the same data with keys in different sequences, and a text diff..." |
*
* @param {Sorter_Body1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_body1 = /** @type {((inputs?: Sorter_Body1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Body1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_body1(inputs)
	if (locale === "ko") return ko_sorter_body1(inputs)
	return ja_sorter_body1(inputs)
});